<template>
  <div>
    <div class="content-header">
      <h2>产品体系</h2>
    </div>
    <div class="content-con">
      <div class="profile-conter">
        <ul class="tab">
          <li
            v-for="(item, index) in productSystemList"
            :key="index"
            class="tab-item"
            :class="{ 'item--active': Mode == index + 1 }"
            @mouseover="handleMouseOver(index + 1)"
          >
            {{ item.name }}
          </li>
        </ul>

        <div class="resumeForm">
          <div>
            <div id="c_static_001-16976318114470" class="response-animated">
              <div class="e_categoryB-1 response-transition" needjs="true">
                <div class="p_c_tree" v-if="productSystemList.length > 0">
                  <ul
                    class="p_c_content deep-1"
                    v-if="productSystemList[Mode - 1].children.length > 0"
                  >
                    <li
                      class="p_c_item"
                      v-for="item in productSystemList[Mode - 1].children"
                    >
                      <p class="p_c_title1 js_editor_click deep">
                        <a href="javascript:;" target="">
                          <span>{{ item.name }}</span>
                        </a>
                        <span class="p_arrbtm">
                          <svg
                            t="1604630783617"
                            class="icon p_arrow"
                            viewBox="0 0 1024 1024"
                            version="1.1"
                            xmlns="https://www.w3.org/2000/svg"
                            p-id="9748"
                            width="200"
                            height="200"
                          >
                            <path
                              d="M725.333333 127.146667a53.333333 53.333333 0 0 0-75.52 0L295.253333 482.133333a42.496 42.496 0 0 0 0 60.16l354.56 354.56c20.906667 20.906667 54.613333 20.906667 75.52 0s20.906667-54.613333 0-75.52L416.426667 512l309.333333-309.333333c20.48-20.906667 20.48-55.04-0.426667-75.52z"
                              p-id="9749"
                            ></path>
                          </svg>
                        </span>
                      </p>
                      <ul
                        class="p_c_content deep-2"
                        style="display: none"
                        v-if="item.children.length > 0"
                      >
                        <li
                          class="p_c_item"
                          v-for="(ite, index) in item.children"
                        >
                          <p
                            class="p_c_title2 js_editor_click deep"
                            @click="toggle1(ite.cmProductSystemId)"
                          >
                            <a href="javascript:;" target="">
                              <span>{{ ite.name }}</span>
                            </a>
                            <span
                              class="p_arrbtm"
                              v-if="ite.children.length > 0"
                            >
                              <svg
                                t="1604630783617"
                                class="icon p_arrow"
                                viewBox="0 0 1024 1024"
                                version="1.1"
                                xmlns="https://www.w3.org/2000/svg"
                                p-id="9748"
                                width="200"
                                height="200"
                              >
                                <path
                                  d="M725.333333 127.146667a53.333333 53.333333 0 0 0-75.52 0L295.253333 482.133333a42.496 42.496 0 0 0 0 60.16l354.56 354.56c20.906667 20.906667 54.613333 20.906667 75.52 0s20.906667-54.613333 0-75.52L416.426667 512l309.333333-309.333333c20.48-20.906667 20.48-55.04-0.426667-75.52z"
                                  p-id="9749"
                                ></path>
                              </svg>
                            </span>
                          </p>
                          <ul
                            class="p_c_content deep-3"
                            v-if="ite.children.length > 0"
                            v-show="active1Index == ite.cmProductSystemId"
                          >
                            <li
                              class="p_c_item"
                              v-for="(it, indexNum) in ite.children"
                            >
                              <p
                                class="p_c_title3 js_editor_click deep"
                                @click="toggle2(it.cmProductSystemId)"
                              >
                                <a href="javascript:;" target="">
                                  <span>{{ it.name }}</span>
                                </a>
                                <span
                                  class="p_arrbtm"
                                  v-if="it.children.length > 0"
                                >
                                  <svg
                                    t="1604630783617"
                                    class="icon p_arrow"
                                    viewBox="0 0 1024 1024"
                                    version="1.1"
                                    xmlns="https://www.w3.org/2000/svg"
                                    p-id="9748"
                                    width="200"
                                    height="200"
                                  >
                                    <path
                                      d="M725.333333 127.146667a53.333333 53.333333 0 0 0-75.52 0L295.253333 482.133333a42.496 42.496 0 0 0 0 60.16l354.56 354.56c20.906667 20.906667 54.613333 20.906667 75.52 0s20.906667-54.613333 0-75.52L416.426667 512l309.333333-309.333333c20.48-20.906667 20.48-55.04-0.426667-75.52z"
                                      p-id="9749"
                                    ></path>
                                  </svg>
                                </span>
                              </p>
                              <ul
                                class="p_c_content deep-4"
                                v-if="it.children.length > 0"
                                v-show="active2Index == it.cmProductSystemId"
                              >
                                <li class="p_c_item" v-for="i in it.children">
                                  <p
                                    class="p_c_title4 js_editor_click deep"
                                    @click="toggle3(i.cmProductSystemId)"
                                  >
                                    <a href="javascript:;" target="">
                                      <span>{{ i.name }}</span>
                                    </a>
                                    <span
                                      class="p_arrbtm"
                                      v-if="i.children.length > 0"
                                    >
                                      <svg
                                        t="1604630783617"
                                        class="icon p_arrow"
                                        viewBox="0 0 1024 1024"
                                        version="1.1"
                                        xmlns="https://www.w3.org/2000/svg"
                                        p-id="9748"
                                        width="200"
                                        height="200"
                                      >
                                        <path
                                          d="M725.333333 127.146667a53.333333 53.333333 0 0 0-75.52 0L295.253333 482.133333a42.496 42.496 0 0 0 0 60.16l354.56 354.56c20.906667 20.906667 54.613333 20.906667 75.52 0s20.906667-54.613333 0-75.52L416.426667 512l309.333333-309.333333c20.48-20.906667 20.48-55.04-0.426667-75.52z"
                                          p-id="9749"
                                        ></path>
                                      </svg>
                                    </span>
                                  </p>
                                  <ul
                                    class="p_c_content deep-5"
                                    v-if="i.children.length > 0"
                                    v-show="active3Index == i.cmProductSystemId"
                                  >
                                    <li
                                      class="p_c_item"
                                      v-for="ng in i.children"
                                    >
                                      <p
                                        class="p_c_title5 js_editor_click deep"
                                      >
                                        <a href="javascript:;" target="">
                                          <span>{{ ng.name }}</span>
                                        </a>
                                      </p>
                                    </li>
                                  </ul>
                                </li>
                              </ul>
                            </li>
                          </ul>
                        </li>
                      </ul>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { getProductSystemTree } from "@/api/index.js";
export default {
  data() {
    return {
      Mode: "1",
      productSystemList: [],
      active1Index: null,
      active2Index: null,
      active3Index: null
    };
  },
  created() {
    this.productSystemTree();
  },
  methods: {
    //产品体系
    productSystemTree() {
      getProductSystemTree('产品体系').then(response => {
        if (response.code == 200) {
          this.productSystemList = this.transListDataToTreeData(
            response.data,
            "395"
          );
        }
      });
    },

    transListDataToTreeData(list, root) {
      const arr = [];
      // 1.遍历
      list.forEach(item => {
        // 2.首次传入空字符串  判断list的pid是否为空 如果为空就是一级节点
        if (item.pid === root) {
          // 找到之后就要去找item下面有没有子节点  以 item.id 作为 父 id, 接着往下找
          const children = this.transListDataToTreeData(
            list,
            item.cmProductSystemId
          );
          if (children.length > 0) {
            // 如果children的长度大于0,说明找到了子节点
            item.children = children;
          }
          // 将item项, 追加到arr数组中
          arr.push(item);
        }
      });
      return arr;
    },

    //移入
    handleMouseOver(index) {
      this.Mode = index;
    },

    toggle1(index) {
      this.active1Index = this.active1Index === index ? null : index;
    },

    toggle2(index) {
      this.active2Index = this.active2Index === index ? null : index;
    },

    toggle3(index) {
      this.active3Index = this.active3Index === index ? null : index;
    }
  }
};
</script>
<style lang="less" scoped>
.profile-conter {
  width: 100%;
  margin-left: auto;
  margin-right: 0px;
  margin-top: 20px;
  background-color: rgba(255, 255, 255, 1);
  .tab {
    display: flex;
    width: 100%;
    margin: 0px auto;
    .tab-item {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      display: block;
      width: calc(100% / 2);
      line-height: 60px;
      text-align: center;
      font-size: 20px;
      cursor: pointer;
      position: relative;
      background-color: #f3f3f3;
    }
    .item--active {
      color: white;
      background-color: #00a0e9;
    }
  }
}

#c_static_001-16976318114470 {
  min-height: 0px;
  background_radio: 2;
  display-radio: 1;
  margin-top: 0px;
  padding-top: 10px;
  padding-bottom: 40px;
}

#c_static_001-16976318114470 .e_categoryB-1 {
  user-select: none;
  font-size: 14px;
  width: 100%;
  max-width: 100%;
  display-radio: 1;
  padding-top: 0px;
  padding-bottom: 0px;
  padding-left: 0px;
  padding-right: 0px;
}

#c_static_001-16976318114470 .e_categoryB-1 ul {
  list-style: none;
  margin: 0;
  display: flex;
}

#c_static_001-16976318114470 .e_categoryB-1 li {
  position: relative;
}

#c_static_001-16976318114470 .e_categoryB-1 .deep a {
  width: calc(100% - 50px);
  width: 100%;
  padding-left: 20px;
  display: flex;
  justify-content: flex-start;
  padding-right: 0px;
}

#c_static_001-16976318114470 .e_categoryB-1 .p_c_title1 {
  display: flex;
  justify-content: space-between;
  position: relative;
  line-height: 60px;
  border-bottom: 1px solid #ebebeb;
  font-size: 20px;
  transition: all ease 0.3s;
  width: 100%;
  color: #29647e;
  background: #c6e3f1;
  font-weight: bold;
  margin-top: 30px;
}

#c_static_001-16976318114470 .e_categoryB-1 .deep-2 {
  width: 100%;
}

#c_static_001-16976318114470 .e_categoryB-1 .p_arrbtm {
  width: 40px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-align: center;
  cursor: pointer;
  border-left: 0px solid rgb(0 0 0 / 5%);
  transition: border-left ease 0.3s;
}

#c_static_001-16976318114470 .e_categoryB-1 .p_arrow {
  margin: 0;
  font-size: 12px;
  transform: rotate(-90deg);
  line-height: 1;
  padding: 0;
  width: auto;
  height: 14px;
  right: 15px;
  pointer-events: none;
}

#c_static_001-16976318114470 .e_categoryB-1 .p_c_title2 {
  display: flex;
  justify-content: space-between;
  position: relative;
  line-height: 60px;
  border-bottom: 1px solid #e1e1e1;
  font-size: 16px;
  transition: all ease 0.3s;
  width: 100%;
  color: #333;
  background: #ededed;
  padding-left: 0px;
}

#c_static_001-16976318114470 .e_categoryB-1 .p_c_title2:before {
  content: "";
  position: absolute;
  width: 7px;
  height: 0px;
  background-color: #333;
  left: 0px;
  transform: translate(0%, -50%);
  top: 50%;
  border-radius: 100%;
}

#c_static_001-16976318114470 .e_categoryB-1 .deep-3 {
  width: 100%;
}

#c_static_001-16976318114470 .e_categoryB-1 .p_c_title3 {
  display: flex;
  justify-content: space-between;
  position: relative;
  line-height: 45px;
  border-bottom: 1px solid rgba(38, 37, 37, 0.06);
  font-size: 15px;
  transition: all ease 0.3s;
  width: 100%;
  color: #666;
  background: #f8f8f8;
  padding-left: 20px;
}

#c_static_001-16976318114470 .e_categoryB-1 .p_c_title3:before {
  content: "";
  position: absolute;
  width: 5px;
  height: 5px;
  background-color: #666;
  left: 30px;
  transform: translate(0%, -50%);
  top: 50%;
  border-radius: 100%;
}

#c_static_001-16976318114470 .e_categoryB-1 .p_c_title4 {
  position: relative;
  background: #fff;
  border-bottom: 1px solid rgba(0, 0, 0, 0.05);
  font-size: 14px;
  line-height: 40px;
  display: flex;
  padding-left: 30px;
  color: #999;
}

#c_static_001-16976318114470 .e_categoryB-1 .p_c_title4:before {
  content: "";
  position: absolute;
  width: 6px;
  height: 6px;
  border: 1px solid #777;
  left: 40px;
  transform: translate(0%, -50%);
  top: 50%;
  border-radius: 100%;
}

#c_static_001-16976318114470 .e_categoryB-1 .p_c_title5 {
  position: relative;
  background: #fff;
  border-bottom: 1px solid rgb(0, 0, 0, 0.05);
  font-size: 12px;
  line-height: 24px;
  display: flex;
  padding-left: 20px;
  color: #999;
}

#c_static_001-16976318114470 .e_categoryB-1 .p_c_title5:before {
  content: "";
  position: absolute;
  width: 5px;
  height: 0px;
  background-color: #777;
  left: 70px;
  transform: translate(0%, -50%);
  top: 50%;
  border-radius: 100%;
}

#c_static_001-16976318114470 .e_categoryB-1 .p_c_images {
  width: 27px;
  height: 100%;
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-right: 6px;
  order: -1;
  overflow: hidden;
  transition: all ease 0.3s;
}

#c_static_001-16976318114470 .e_categoryB-1 .p_c_images img {
  width: 100%;
  height: auto;
  vertical-align: middle;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

#c_static_001-16976318114470 .e_categoryB-1 p:hover .p_c_images {
  opacity: 0;
  margin-right: 0px;
  width: 0px;
}

#c_static_001-16976318114470 .e_categoryB-1 .deep:hover {
  background: #00a0e9;
  color: #fff;
  border-bottom: 1px solid initial;
}

#c_static_001-16976318114470 .e_categoryB-1 .deep:hover:before {
  background-color: #fff;
}

#c_static_001-16976318114470 .e_categoryB-1 .active > p {
  background: #007bff;
  color: #fff;
  border-bottom: 1px solid #007bff;
}

#c_static_001-16976318114470 .e_categoryB-1 .deep:hover .p_arrbtm {
  border-left: 1px solid rgb(255 255 255 / 10%);
}

#c_static_001-16976318114470 .e_categoryB-1 li:last-child > .deep {
  border-bottom: 0px solid #ebebeb;
}

#c_static_001-16976318114470 .e_categoryB-1 .deep-1 .p_c_item {
  padding-right: 15px;
  flex: 0 0 calc((100%) / 3);
}

#c_static_001-16976318114470 .e_categoryB-1 .deep-1 .p_c_item:nth-child(3n) {
  padding-right: 0px;
}

#c_static_001-16976318114470 .e_categoryB-1 .deep-2 .p_c_item {
  margin-right: 0px;
  padding-right: 0px;
}

#c_static_001-16976318114470 .e_categoryB-1 .p_c_title1 svg {
  color: #fff;
  display: none;
}

#c_static_001-16976318114470 .e_categoryB-1 .p_c_content {
  display-radio: 1;
  flex-wrap: wrap;
}

#c_static_001-16976318114470 .e_categoryB-1 .p_c_item > .deep-2 {
  display: block !important;
}

#c_static_001-16976318114470 .e_categoryB-1 .deep-3 .p_c_item {
  width: 100%;
  flex: none;
}

@media screen and (max-width: 768px) {
  #c_static_001-16976318114470 .e_categoryB-1 {
    background: none;
    max-width: none;
    display: flex;
    justify-content: flex-end;
  }

  #c_static_001-16976318114470 .e_categoryB-1 .p_c_tree {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 100%;
    height: 100vh;
    width: 70%;
    transition: all ease 0.5s;
    background: #fff;
    z-index: 1000;
    max-height: 1080px;
  }

  #c_static_001-16976318114470 .e_categoryB-1 .deep-1 {
    height: 100%;
    overflow-y: auto;
    overflow-x: hidden;
  }

  #c_static_001-16976318114470 .e_categoryB-1 .p_c_mbtn {
    display: block;
    border: 0;
    background: #007bff;
    padding: 10px 15px;
    border-radius: 2px;
    font-size: 14px;
    color: rgb(255 255 255 / 80%);
    outline: none;
  }

  #c_static_001-16976318114470 .e_categoryB-1 .p_c_mput {
    display: block;
    line-height: 50px;
    background: rgb(0 0 0 / 70%);
    position: fixed;
    top: 0;
    bottom: 0;
    right: 0;
    left: 0;
    max-height: 1080px;
    height: 100vh;
    width: 100%;
    cursor: pointer;
    transition: all ease 0.5s;
    opacity: 0;
    visibility: hidden;
    z-index: 999;
  }

  #c_static_001-16976318114470 .e_categoryB-1 .p_c_mput:hover {
    background: rgb(0 0 0 / 80%);
  }

  #c_static_001-16976318114470 .e_categoryB-1 .deep a {
    padding-right: 15px;
    width: 100%;
  }

  #c_static_001-16976318114470 .e_categoryB-1 .deep {
    color: #666;
  }

  #c_static_001-16976318114470 .e_categoryB-1 .deep-2 {
    display: none;
    position: static;
    width: 100%;
  }

  #c_static_001-16976318114470 .e_categoryB-1 .deep-3 {
    // display: none;
    position: static;
    width: 100%;
    background: #dfdfdf;
  }

  #c_static_001-16976318114470 .e_categoryB-1 .deep-3 .p_c_item {
    width: 100%;
  }

  #c_static_001-16976318114470 .e_categoryB-1 .p_c_title3 {
    border-bottom: 1px solid #d5d5d5;
  }

  #c_static_001-16976318114470 .e_categoryB-1.design_nomput .p_c_mput {
    display: none;
  }

  #c_static_001-16976318114470 .e_categoryB-1 .p_leftani {
    left: 30%;
  }

  #c_static_001-16976318114470 .e_categoryB-1 .p_bg_show {
    opacity: 1;
    visibility: visible;
    display: block;
  }
}

@media screen and (min-width: 769px) {
  #c_static_001-16976318114470 .e_categoryB-1 .p_c_mbtn,
  #c_static_001-16976318114470 .e_categoryB-1 .p_c_mput,
  #c_static_001-16976318114470 .e_categoryB-1 .p_c_item > .p_c_content {
    // display: none;
  }
}

@media screen and (max-width: 1024px) and (min-width: 769px) {
}
</style>
